function initForm(){
  const $form   = $('.js-required-form'),
        $submit = $form.find('.js-submit');

  if (!$form.length) return;

  function toggleSubmit(){
    let allFilled = true;
    let allValid = true;
    // required属性のある input を全部チェック
    $form.find('input[required]').each(function(){
      if (!$(this).val().trim()) {
        allFilled = false;
        return false;
      }
    });

    // パスワード最小文字数（表示は動的に）
    $form.find('input.js-password-minlength').each(function(){
      const $input = $(this);
      const minLength = parseInt($input.attr('minlength') || '0', 10);
      const value = ($input.val() || '').toString();

      const $wrap = $input.closest('.c-form__input-wrap');
      const $feedback = $wrap.parent().find('.c-form__invalid-feedback').first();

      const invalid = minLength > 0 && value.length > 0 && value.length < minLength;
      $wrap.toggleClass('c-form__input-wrap--invalid', invalid);
      $feedback.toggleClass('u-dn', !invalid);

      if (invalid) allValid = false;
    });

    $submit.prop('disabled', !allFilled || !allValid);
  }

  $form.off('input change', 'input[required]', toggleSubmit)
       .on('input change', 'input[required]', toggleSubmit);
  $form.off('input change', 'input.js-password-minlength', toggleSubmit)
       .on('input change', 'input.js-password-minlength', toggleSubmit);

  // 初回チェック
  toggleSubmit();
}

document.addEventListener('DOMContentLoaded', initForm);
document.addEventListener('turbolinks:load', initForm);
document.addEventListener('turbo:load', initForm);